module.exports = __webpack_public_path__ + "img/b0eff577b04507d5cad4d2a7470c779d.png";